import BaseModel from 'src/model/base.model';

class AccountModel extends BaseModel {
  public accountId: string = '';
  public name: string = '';
  public userId: string = '';
  public hasInvoicePermission: boolean = true;
  public email: string = '';
  public echeckStatus: boolean = true;
}

export default AccountModel;
